// extracted by mini-css-extract-plugin
export default {"contactInfo":"Disclaimer_contactInfo__b7XHH","disclaimerLink":"Disclaimer_disclaimerLink__Tu3+X","image":"Disclaimer_image__hLhKf"};